import React from "react";
import { ArrowRight } from "lucide-react";

/**
 * Sitewide CTA block — reused on every authority page.
 * Default headline/sub copy comes from the spec but can be overridden.
 *
 *   "What does AI say about your business?"
 *   "Get your AI Visibility Score™ in 48 hours. No pitch. Just your score."
 *   [Request a Free Snapshot] → https://theentityagency.com
 */
export default function CtaBlock({
  headline = "What does AI say about your business?",
  subhead = "Get your AI Visibility Score™ in 48 hours. No pitch. Just your score.",
  buttonLabel = "Request a Free Snapshot",
  href = "https://theentityagency.com",
  variant = "border",          // "border" | "panel" | "compact"
  testId = "global-cta-block",
}) {
  const isPanel = variant === "panel";
  const isCompact = variant === "compact";

  return (
    <section
      data-testid={testId}
      className={
        isPanel
          ? "border-y border-[#2a2620] bg-[#0c0a08]"
          : "border-t border-[#2a2620]"
      }
    >
      <div className={`max-w-4xl mx-auto px-6 sm:px-8 ${isCompact ? "py-10" : "py-16"} text-center`}>
        <p className="font-mono-eav text-[11px] tracking-[0.24em] uppercase text-[#b8963e]">
          The AI Visibility Score™
        </p>
        <h2 className={`mt-4 font-serif-display text-[#f4efe6] leading-tight ${isCompact ? "text-2xl sm:text-3xl" : "text-3xl sm:text-4xl"}`}>
          {headline}
        </h2>
        <p className="mt-4 text-base sm:text-lg text-[#c9bca4]">{subhead}</p>
        <a href={href}
            data-testid={`${testId}-button`}
            className="mt-8 inline-flex items-center gap-2 btn-gold">
          {buttonLabel} <ArrowRight className="w-4 h-4" />
        </a>
      </div>
    </section>
  );
}
